
export default {
  'CUSTOMER': {
    title: '客户编码',
    type: 'dialog',
    dialog: {
      component: 'ClientSelect',
      title: '客户编码'
    },
    width: 200
  },

  'CUST_NAME': {
    title: '客户名称',
    type: 'input',
    width: 'auto'
  },
}



// WEBPACK FOOTER //
// ./src/views/client-manage/config/customerDeploy.js